/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ScenarioRequest model module.
 * @module model/ScenarioRequest
 * @version 0.0.2
 */
class ScenarioRequest {
    /**
     * Constructs a new <code>ScenarioRequest</code>.
     * @alias module:model/ScenarioRequest
     */
    constructor() { 
        
        ScenarioRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScenarioRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScenarioRequest} obj Optional instance to populate.
     * @return {module:model/ScenarioRequest} The populated <code>ScenarioRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScenarioRequest();

            if (data.hasOwnProperty('scenarioId')) {
                obj['scenarioId'] = ApiClient.convertToType(data['scenarioId'], 'String');
            }
            if (data.hasOwnProperty('scenarioName')) {
                obj['scenarioName'] = ApiClient.convertToType(data['scenarioName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ScenarioRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ScenarioRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['scenarioId'] && !(typeof data['scenarioId'] === 'string' || data['scenarioId'] instanceof String)) {
            throw new Error("Expected the field `scenarioId` to be a primitive type in the JSON string but got " + data['scenarioId']);
        }
        // ensure the json data is a string
        if (data['scenarioName'] && !(typeof data['scenarioName'] === 'string' || data['scenarioName'] instanceof String)) {
            throw new Error("Expected the field `scenarioName` to be a primitive type in the JSON string but got " + data['scenarioName']);
        }

        return true;
    }


}



/**
 * The unique Scenario ID
 * @member {String} scenarioId
 */
ScenarioRequest.prototype['scenarioId'] = undefined;

/**
 * Optional name to lookup example scenarios
 * @member {String} scenarioName
 */
ScenarioRequest.prototype['scenarioName'] = undefined;






export default ScenarioRequest;

